import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue, {BootstrapVueIcons, VBPopoverPlugin} from "bootstrap-vue";
import VueCompositionAPI from '@vue/composition-api'
import i18n from './i18n'

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VBPopoverPlugin);


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
